import { JsonObject, JsonProperty } from 'json2typescript';
import { SchoolAddress } from './school-address';

/**
 * å­¦æ ¡
 */
@JsonObject
export class School {

  /**
   * å®ä½id
   */
  @JsonProperty('id', Number, true)
  id: number = undefined;

  /**
   * åå»ºæ¶é´, æ¶é´æ³
   */
  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  /**
   * æåä¿®æ¹æ¶é´, æ¶é´æ³
   */
  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  /**
   * ç®¡çåè´¦å·Id
   */
  @JsonProperty('accountId', Number)
  accountId: number = undefined;

  /**
   * å»é¢åç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;

  /**
   * å»é¢å«å
   */
  @JsonProperty('alias', Number)
  alias: string = undefined;

  /**
   * å»é¢èç³»çµè¯
   * ä¾: 021-2222221
   */
  @JsonProperty('contact', String)
  contact: string = undefined;

  /**
   * å»é¢æè¿°
   */
  @JsonProperty('desc', String)
  desc: string = undefined;

  /**
   * ç¦ç¨å¯ç¨ç¶æ
   */
  @JsonProperty('enabled', Boolean)
  enabled: boolean = undefined;

  /**
   * å»é¢å°å
   */
  @JsonProperty('address', SchoolAddress)
  address: SchoolAddress = undefined;
}
